<template>
    <section class="position-control form-group col-lg-12">
        <input type="number" v-model="innPos" @change="changePos" class="form-control form-control-sm">
    </section>
</template>


<script>
    export default {
        props: ['apiUrl', 'position'],

        data() {
            return {
                innPos: this.position
            }
        },

        methods: {
            changePos() {
                axios.patch(this.apiUrl, {position: this.innPos}).then( response => {
                    location.reload();
                });
            }
        }
    }
</script>